import { getNestedValue } from "./getNestedValue";

// Get a sortable value for the column
export function getSortableValue(obj: unknown, key: string): unknown {
  const value = getNestedValue(obj, key);
  // If it's an object (like user), pick "name" if available, otherwise first primitive
  if (value && typeof value === "object") {
    const entries = Object.entries(value as Record<string, unknown>);
    // Prefer "name"
    if ("name" in (value as Record<string, unknown>)) {
      return (value as Record<string, unknown>)["name"];
    }
    // Otherwise, find the first primitive property
    for (const [, v] of entries) {
      if (v != null && typeof v !== "object") {
        return v;
      }
    }
    return JSON.stringify(value); // fallback
  }
  return value;
}
